<template>
  <div class="borrowClass" id="borrow" ref="borrow">
    <!-- 操作按钮组 -->
    <!-- 绘制架构图盒子 -->
    <div id="appc" ref="appc" style="width: 100%; height: 100%"></div>
    <!--    <div id="tooltip" class="tooltip-hover" style="display: flex;padding: 14px;display: none;">-->
    <div
      id="tooltip"
      class="tooltip-hover"
      style="display: flex; padding: 14px; display: none"
    >
      <!-- <div style="">
        <TxtLogoSmall
          style="width: 30px; height: 30px; border-radius: 4px"
          :key="item.companyName"
          :companyName="item.companyName"
          :isEnCompany="item.companyCountry !== 'CN'"
        />
      </div> -->
      <div style="flex: 1; padding-left: 10px ; max-width: 320px;
            font-family: 'DMSans Bold';
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;">
        <div
          id="entname"
          style="
            color: #1a2332;
            font-size: 16px;
              line-height: 20px;
            max-width: 320px;
            font-family: 'DMSans Bold';
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
        ></div>
        <div style="margin-top: 10px; display: flex">
          <div
            id="entstatus"
            class="_company-status-tag"
            style="
              color: #3fb92f;
              background: #f3fff2;
              border: 1px solid #3fb92f;
            "
          ></div>
          <div
            id="country"
            style="
              margin-left: 10px;
              padding-left: 10px;
              font-size: 12px;
              color: #1a2332;
              border-left: 1px solid #dddddd;
              max-width: 150px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          ></div>
          <div
            id="enttype"
            style="
              margin-left: 10px;
              padding-left: 10px;
              font-size: 12px;
              color: #1a2332;
              border-left: 1px solid #dddddd;
              max-width: 100px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import { mixins1 } from "@/mixins/index";
// import { encryptPsw } from "@/util/encryptor";
import crypto from "@/utils/crypto.js";
import { getCompanyDetailchirt } from "@/api/companyApi";
// import TxtLogoSmall from "@/components/txtLogoSmall.vue";

export default {
  name: "EquityD3",
  mixins: [mixins1],

  //   components: { TxtLogoSmall },
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    chartType: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {
      config: {
        // 节点的横向距离
        dx: 200,
        // 节点的纵向距离
        dy: 170,
        // svg的viewBox的宽度
        width: 0,
        // svg的viewBox的高度
        height: 0,
        // 节点的矩形框宽度
        rectWidth: 170,
        // 节点的矩形框高度
        rectHeight: 70,
        // 控股人div半径
        radius: 70,

        rectHoverDivWidth: 334,
        rectHoverDivHeight: 104,
      },
      appcStyle: null,
      svgs: null,
      gAlls: null,
      gLinks: null,
      gNodes: null,
      myZoom: null,
      // 给树加坐标点的方法
      tree: null,
      // 投资公司树的根节点
      rootOfDown: null,
      // 股东树的根节点
      rootOfUp: null,
      //是否全屏
      isFullscreen: true,
      tooltip: null,
      d3ShowData: null,
      svg: null,
      item: {
        companyName: "",
        companyCountry: "",
      },
    };
  },
  mounted() {
    this.tooltip = d3.select("#borrow>#tooltip").node().cloneNode(true);
    if (this.chartData != null) {
      this.d3ShowData = JSON.parse(JSON.stringify(this.chartData));
    }
  },
  watch: {
    chartData: function (val) {
      if (val) {
        this.d3ShowData = JSON.parse(JSON.stringify(val)); // 对象引用解绑
      }
    },
    d3ShowData: {
      handler(val, oldV) {
        if (val) {
          let that = this;
          this.$nextTick(() => {
            that.drawChart({
              type: "fold",
            });
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    async getCompanyDetailchirt(aaa_id, countryCode, event, node) {
      let params = {
        id3a: aaa_id,
        page: "1",
        pageSize: "50",
      };
      let res = await getCompanyDetailchirt(params);
      if (res.code) {
        let data = res.data;
        data = JSON.parse(JSON.stringify(data).replace(/name/g, "entname"));
        data = JSON.parse(
          JSON.stringify(data).replace(/entnameNative/g, "entnameen")
        );

        if (data != null && JSON.stringify(data) !== "{}") {
          const basic = node.data; // res.data["basic"];
          basic.parents = data["shareholders"] || [];
          basic.children = data["entinvs"] || [];
          // basic.fundedratio = node.data.fundedratio;
          // 为个人股东生成唯一 ID（你原来的逻辑）
          // basic.parents.forEach((item) => {
          //   if (item["invtypecode"] === "1") {
          //     item["aaa_id"] = item["subconam"]; // 注意可能仍需改善
          //   }
          // });

          // 替换节点
          const replaced = this.replaceNodeInTree(this.d3ShowData, basic);

          // 如果整棵树中都找不到就插入到最顶层
          if (!replaced) {
            this.d3ShowData.parents = this.d3ShowData.parents || [];
            this.d3ShowData.parents.push(basic);
          }
          // 合并当前公司节点进图谱
          // this.d3ShowData.parents.push(basic); //= this.mergeTree(this.d3ShowData, basic);
          this.drawChart();
        }
      }
    },

    // 在任意层级递归查找并删除
    replaceNodeInTree(treeNode, newNode) {
      if (!treeNode) return false;
      const replaceInList = (list) => {
        if (!Array.isArray(list)) return false;
        const index = list.findIndex((item) => item.aaa_id === newNode.aaa_id);
        if (index !== -1) {
          list.splice(index, 1, newNode); // 删除旧的并插入新的
          return true;
        }

        // 没找到，递归子节点
        for (const item of list) {
          if (this.replaceNodeInTree(item, newNode)) {
            return true;
          }
        }
        return false;
      };

      return (
        replaceInList(treeNode.parents) || replaceInList(treeNode.children)
      );
    },

    findNodeById(node, aaa_id, type) {
      if (node.aaa_id === aaa_id) return node;
      if (node.children && type == "children") {
        for (let child of node.children) {
          const found = this.findNodeById(child, aaa_id, "children");
          if (found) return found;
        }
      }
      if (node.parents && type == "parent") {
        for (let parent of node.parents) {
          const found = this.findNodeById(parent, aaa_id, "parent");
          if (found) return found;
        }
      }
      return null;
    },
    resizeFun() {
      //ESC退出全屏改变图表
      if (!this.checkFull()) {
        this.isFullscreen = true;
      }
      const svg = document.getElementById("mysvg");
      svg.setAttribute("height", window.innerHeight);
    },
    drawChart(options, shouldCenter = false, centerNode = null) {
      // 宿主元素的d3选择器对象
      let host = d3.select("#appc");
      // 宿主元素的DOM，通过node()获取到其DOM元素对象
      let dom = host.node();
      // 宿主元素的DOMRect 宽高
      // let domRect = dom.getBoundingClientRect();
      // 设置盒子宽高
      // domRect.width = this.$refs.borrow.offsetWidth;
      // domRect.height = this.$refs.borrow.offsetHeight;
      // svg的宽度和高度
      this.config.width = this.$refs.borrow.offsetWidth;
      this.config.height = this.$refs.borrow.offsetHeight;
      let svg = host.select("svg");
      if (svg.empty()) {
        svg = host
          .append("svg")
          .attr("id", "mysvg")
          .attr("viewBox", () => {
            let parentsLength = this.d3ShowData.parents
              ? this.d3ShowData.parents.length
              : 0;

            return [
              //聚焦位置x
              -(this.config.width / 2),
              // 聚焦位置y。如果有父节点，则根节点居中，否则根节点上浮一段距离
              parentsLength > 0
                ? -(this.config.height / 2)
                : -(this.config.height / 3),
              this.config.width,
              this.config.height,
            ];
          })
          .attr("width", this.config.width)
          .attr("height", this.config.height)
          .style("user-select", "none")
          .style("cursor", "move")
          .style("background", "#ffffff");
        // 包括连接线和节点的总集合
        const gAll = svg.append("g").attr("id", "all");
        this.gAlls = gAll;
        // 连接线集合
        this.gLinks = gAll.append("g").attr("id", "linkGroup");
        // 节点集合
        this.gNodes = gAll.append("g").attr("id", "nodeGroup");
        this.myZoom = d3
          .zoom()
          .scaleExtent([0.5, 2])
          .on("zoom", (e) => {
            d3.select("#all").attr(
              "transform",
              `translate(${e.transform.x},${e.transform.y}) scale(${e.transform.k})`
            );
          });

        svg.call(this.myZoom).on("dblclick.zoom", null); // 取消默认的双击放大事件
        this.svg = svg;
      } else {
        this.svg = svg;
        this.gAlls = svg.select("#all");
        this.gLinks = svg.select("#linkGroup");
        this.gNodes = svg.select("#nodeGroup");
      }
      const currentTransform = d3.zoomTransform(this.svg.node());
      this.gLinks.selectAll("*").remove();
      this.gNodes.selectAll("*").remove();

      // 设置好节点之间距离的tree方法
      this.tree = d3.tree().nodeSize([this.config.dx, this.config.dy]);

      this.rootOfDown = d3.hierarchy(this.d3ShowData, (d) => d.children);
      this.rootOfUp = d3.hierarchy(this.d3ShowData, (d) => d.parents);
      this.tree(this.rootOfDown);
      // [this.rootOfDown.descendants(), this.rootOfUp.descendants()].forEach(
      //   (nodes) => {
      //     nodes.forEach((node) => {
      //       node._children = node.children || null;
      //       if (options.type === "all") {
      //         //如果是all的话，则表示全部都展开
      //         node.children = node._children;
      //       } else if (options.type === "fold") {
      //         //如果是fold则表示除了父节点全都折叠
      //         // 将非根节点的节点都隐藏掉（其实对于这个组件来说加不加都一样）
      //         if (node.depth) {
      //           node.children = null;
      //         }
      //       }
      //     });
      //   }
      // );
      //箭头(下半部分)
      svg
        .append("marker")
        .attr("id", "markerOfDown")
        .attr("markerUnits", "userSpaceOnUse")
        .attr("viewBox", "0 -5 10 10") //坐标系的区域
        .attr("refX", 45) //箭头坐标
        .attr("refY", 0)
        .attr("markerWidth", 10) //标识的大小
        .attr("markerHeight", 10)
        .attr("orient", "90") //绘制方向，可设定为：auto（自动确认方向）和 角度值
        .attr("stroke-width", 2) //箭头宽度
        .append("path")
        .attr("d", "M0,-5L10,0L0,5") //箭头的路径
        .attr("fill", "#D3D3D3"); //箭头颜色
      //箭头(上半部分)
      svg
        .append("marker")
        .attr("id", "markerOfUp")
        .attr("markerUnits", "userSpaceOnUse")
        .attr("viewBox", "0 -5 10 10") //坐标系的区域
        .attr("refX", -90) //箭头坐标
        .attr("refY", 0)
        .attr("markerWidth", 10) //标识的大小
        .attr("markerHeight", 10)
        .attr("orient", "90") //绘制方向，可设定为：auto（自动确认方向）和 角度值
        .attr("stroke-width", 2) //箭头宽度
        .append("path")
        .attr("d", "M0,-5L10,0L0,5") //箭头的路径
        .attr("fill", "#D3D3D3"); //箭头颜色

      this.svgs = svg;
      this.update();
      // 将svg置入宿主元素中
      host.append(function () {
        return svg.node();
      });

      if (shouldCenter) {
        const target = centerNode || this.rootOfDown;
        const [x, y] = [target.x || 0, target.y || 0];
        const scale = currentTransform.k || 1;

        const transform = d3.zoomIdentity
          .translate(this.config.width / 2 - x, this.config.height / 2 - y)
          .scale(scale);

        this.svg
          .transition()
          .duration(750)
          .call(this.myZoom.transform, transform);
      } else {
        this.svg.call(this.myZoom.transform, currentTransform);
      }
    },
    update(source) {
      if (!source) {
        source = {
          x0: 0,
          y0: 0,
        };
        // 设置根节点所在的位置（原点）
        this.rootOfDown.x0 = 0;
        this.rootOfDown.y0 = 0;
        this.rootOfUp.x0 = 0;
        this.rootOfUp.y0 = 0;
      }
      let self = this;
      let nodesOfDown = this.rootOfDown.descendants().reverse();
      let linksOfDown = this.rootOfDown.links();
      let nodesOfUp = this.rootOfUp.descendants().reverse();
      let linksOfUp = this.rootOfUp.links();
      this.tree(this.rootOfDown);
      this.tree(this.rootOfUp);
      const myTransition = this.svgs.transition().duration(500);

      /***  绘制股东树(上)  ***/

      nodesOfUp.forEach((node) => {
        node.y = -node.y;
      });

      const node2 = this.gNodes
        .selectAll("g.nodeOfUpItemGroup")
        .data(nodesOfUp, (d) => {
          return d.data.aaa_id;
        });

      const nodeOfUpItemGroup = node2
        .enter()
        .append("g")
        .attr("class", "nodeOfUpItemGroup")
        .attr("transform", (d) => {
          return `translate(${source.x0},${source.y0})`;
        })
        .attr("fill-opacity", 0)
        .attr("stroke-opacity", 0)
        .style("cursor", "pointer")
        .on("mouseover", function (mouseEvent, node) {
          if (node.depth == 0) return;
          let g = d3.select(this);
          g.select("#rectG").style("display", "block");
          let oldTooltip = g.select("#tooltip");
          // 如果宿主元素中包含svg标签了，那么则删除这个标签，再重新生成一个
          if (!oldTooltip.empty()) {
            oldTooltip.remove();
          }

          if (self.isCN(node)) {
            // 国内公司
            self.item.companyName = node.data.entname;
            self.item.companyCountry = node.data.countrycode;
          } else {
            // 国际公司
            self.item.companyName = node.data.entname;
            self.item.companyCountry = node.data.countrycode;
          }
          self.$nextTick(() => {
            self.tooltip = d3.select("#borrow>#tooltip").node().cloneNode(true);
            g.select("#foreignObject").node().appendChild(self.tooltip);
            let tooltipG = g.select("#tooltip");
            if (self.isCN(node)) {
              tooltipG
                .select("#entname")
                .text(node.data.entname ? node.data.entname : "");
              tooltipG
                .select("#entstatus")
                .text(node.data.entstatus ? node.data.entstatus : "");
              tooltipG
                .select("#country")
                .text(
                  "Country：" + (node.data.country ? node.data.country : "")
                );
              tooltipG.select("#enttype").text(node.data.enttype);
            } else {
              tooltipG
                .select("#entname")
                .text(node.data.entname ? node.data.entname : "");
              tooltipG
                .select("#entstatus")
                .text(node.data.entstatus ? node.data.entstatus : "");
              tooltipG
                .select("#country")
                .text(
                  "Country：" + (node.data.country ? node.data.country : "")
                );
              tooltipG
                .select("#enttype")
                .text(node.data.enttype ? node.data.enttype : "");
            }
            // 提示框在营颜色
            let selection = tooltipG.select("#entstatus");

            let entstatusTxt = selection.text();
            switch (entstatusTxt) {
              case "Active":
              case "Active":
              case "Active":
                selection.style("color", "#3FB92F");
                selection.style("background", "#F3FFF2");
                selection.style("border", "1px solid #3FB92F");
                break;
              default:
                selection.style("color", "#F89898");
                selection.style("background", "#FDE2E2");
                selection.style("border", "1px solid #F89898");
                break;
            }
            tooltipG.style("display", "flex");
          });
        })
        .on("mouseout", function (mouseEvent, node) {
          let g = d3.select(this);
          g.select("#rectG").style("display", "none");
        });

      //绘制图形框
      nodeOfUpItemGroup
        .append("rect")
        .attr("id", "mainRect")
        .attr("width", (d) => {
          if (self.isPerson(d)) {
            // 控股人
            return this.config.radius;
          } else {
            // 公司
            if (d.depth === 0) {
              //根节点
              if (self.isCN(d)) {
                return (d.data.entname?.length + 6) * 16;
              } else {
                return (d.data.entname?.length + 6) * 10;
              }
            }
            return this.config.rectWidth;
          }
        })
        .attr("height", (d) => {
          if (self.isPerson(d)) {
            // 控股人
            return this.config.radius;
          } else {
            // 公司
            if (d.depth === 0) {
              //根节点
              return 50;
            }
            return this.config.rectHeight;
          }
        })
        .attr("x", (d) => {
          if (self.isPerson(d)) {
            return -(this.config.radius / 2);
          } else {
            if (d.depth === 0) {
              if (self.isCN(d)) {
                return (-(d.data.entname?.length + 6) * 16) / 2;
              } else {
                return (-(d.data.entname?.length + 6) * 10) / 2;
              }
            }
            return -(this.config.rectWidth / 2);
          }
        })
        .attr("y", (d) => {
          if (self.isPerson(d)) {
            return -(this.config.radius / 2);
          } else {
            if (d.depth === 0) {
              return -20;
            }
            return -(this.config.rectHeight / 2);
          }
        })
        .attr("rx", (d) => {
          if (self.isPerson(d)) {
            return this.config.radius / 2;
          } else {
            return 4;
          }
        }) //   边缘圆角
        .attr("stroke-width", 1)
        .attr("stroke", (d) => {
          if (self.isPerson(d)) {
            return "#FF7D18";
          } else {
            if (d.depth === 0) {
              return "#D3D3D3";
            }
            return "#D3D3D3";
          }
        })
        .attr("fill", (d) => {
          if (d.depth === 0 && this.chartType === "risk") {
            return "#F9722C";
          }
          if (d.depth === 0 && this.chartType === "default") {
            return "#1290C9";
          }
          return "#FFFFFF";
        })
        .on("click", (e, d) => {
          this.nodeClickEvent(e, d);
        })
        .on("mouseover", function (mouseEvent, node) {
          if (node.depth === 0) {
          } else {
            let g = d3.select(this.parentNode);
            g.select("#mainRect").style("stroke", "#016FF6");
            g.select("#mainCompanyName").style("fill", "#016FF6");
            g.select("#subCompanyName").style("fill", "#016FF6");
          }
        })
        .on("mouseout", function (mouseEvent, node) {
          if (node.depth === 0) {
          } else {
            let g = d3.select(this.parentNode);
            if (self.isPerson(node)) {
              g.select("#mainRect").style("stroke", "#FF7D18");
            } else {
              g.select("#mainRect").style("stroke", "#D3D3D3");
            }
            g.select("#mainCompanyName").style("fill", "#1A2332");
            g.select("#subCompanyName").style("fill", "#1A2332");
          }
        });
      this.rectHoverDiv(nodeOfUpItemGroup);
      // 文本主标题
      nodeOfUpItemGroup
        .append("text")
        .attr("id", "mainCompanyName")
        .attr("x", (d) => {
          return 0;
        })
        .attr("y", (d) => {
          if (d.depth === 0) {
            return 10;
          } else {
            if (self.isCN(d)) {
              if (d.data.entname?.length < 12) {
                return 5;
              }
            } else {
              if (d.data.entname?.length < 18) {
                return 5;
              }
            }
            return -4;
          }
        })
        .attr("text-anchor", (d) => {
          return "middle";
        })
        .text((d) => {
          if (d.depth === 0) {
            return d.data.entname;
          } else {
            if (self.isPerson(d)) {
              return d.data.entname && d.data.entname.length > 11
                ? d.data.entname.substring(0, 18)
                : d.data.entname;
            } else {
              if (self.isCN(d)) {
                return d.data.entname && d.data.entname.length > 11
                  ? d.data.entname.substring(0, 11)
                  : d.data.entname;
              } else {
                return d.data.entname && d.data.entname.length > 18
                  ? d.data.entname.substring(0, 18)
                  : d.data.entname;
              }
            }
          }
        })
        .attr("fill", (d) => {
          //公司名称颜色
          if (d.depth === 0) {
            return "#FFFFFF";
          }
          return "#1A2332";
        })
        .style("font-size", (d) => (d.depth === 0 ? 16 : 14))
        .style("font-family", "DMSans DMSans")
        .style("font-weight", "normal")
        // .append("svg:title")
        // .text((d) => d.data.entname)
        .style("pointer-events", "none");
      // 副标题
      nodeOfUpItemGroup
        .append("text")
        .attr("id", "subCompanyName")
        .attr("x", (d) => {
          return 0;
        })
        .attr("y", (d) => {
          return 15;
        })
        .attr("text-anchor", (d) => {
          return "middle";
        })
        .attr("fill", (d) => {
          return "#1A2332";
        })
        .text((d) => {
          if (d.depth !== 0) {
            if (self.isCN(d)) {
              let subTitle = d.data.entname ? d.data.entname.substring(11) : "";
              if (subTitle.length > 10) {
                return subTitle.substring(0, 10) + "...";
              }
              return subTitle;
            } else {
              let subTitle = d.data.entname ? d.data.entname.substring(18) : "";
              if (subTitle.length > 17) {
                return subTitle.substring(0, 17) + "...";
              }
              return subTitle;
            }
          }
        })
        .style("font-size", (d) => 14)
        .style("font-family", "DMSans DMSans")
        .style("font-weight", "normal")
        // .append("svg:title")
        // .text((d) => d.data.entname)
        .style("pointer-events", "none");

      //注销
      nodeOfUpItemGroup
        .append("svg:rect")
        .attr("x", (d) => {
          return -(this.config.rectWidth / 2) - 1;
        })
        .attr("y", (d) => {
          return -(this.config.rectHeight / 2) - 6;
        })
        .attr("rx", 2) //   边缘圆角
        .attr("width", function (d) {
          if (d.depth !== 0) {
            if (self.isCN(d)) {
              return d.data.entstatus != null
                ? d.data.entstatus.length * 13 + 9
                : 0;
            } else {
              return d.data.entstatus != null
                ? d.data.entstatus.length * 8 + 9
                : 0;
            }
          }
          return 0;
        })
        .attr("height", function (d) {
          return d.depth !== 0 && d.data.entstatus != null ? 20 : 0;
        })
        .style("fill", (d) => {
          let fillColor = "#FDE2E2";
          // 左上方格填充颜色
          if (self.isCN(d)) {
            // 中国
            if (d.data.entstatus != null) {
              switch (d.data.entstatus) {
                case "Active": //在营
                  fillColor = "#F3FFF2";
                  break;
                case "Active": //在业
                  fillColor = "#F3FFF2";
                  break;
              }
            }
          } else {
            // 国际
            if (d.data.entstatus != null) {
              switch (d.data.entstatus) {
                case "Active": //在营
                  fillColor = "#F3FFF2";
                  break;
                default:
                  fillColor = "#FDE2E2";
                  break;
              }
            }
          }
          return fillColor;
        });
      nodeOfUpItemGroup
        .append("text")
        .attr("x", (d) => {
          return -(this.config.rectWidth / 2) + 5;
        })
        .attr("dy", (d) => {
          return -(this.config.rectHeight / 2) + 8;
        })
        .attr("text-anchor", "start")
        .style("fill", (d) => {
          let fillColor = "#F89898";
          // 左上方格填充颜色
          if (self.isCN(d)) {
            if (d.data.entstatus != null) {
              switch (d.data.entstatus) {
                case "Active": //在业
                  fillColor = "#3FB92F";
                  break;
                case "Active": //在业
                  fillColor = "#3FB92F";
                  break;
                default:
                  fillColor = "#F89898";
                  break;
              }
            }
          } else {
            if (d.data.entstatus != null) {
              switch (d.data.entstatus) {
                case "Active": //在营
                  fillColor = "#3FB92F";
                  break;
                default:
                  fillColor = "#F89898";
                  break;
              }
            }
          }
          return fillColor;
        })
        .style("font-size", 12)
        .text(function (d) {
          if (d.depth !== 0) {
            if (self.isCN(d)) {
              return d.data.entstatus != null ? d.data.entstatus : "";
            } else {
              return d.data.entstatus != null ? d.data.entstatus : "";
            }
          }
          return "";
        });
      nodeOfUpItemGroup
        .append("image")
        .attr("xlink:href", (d) => {
          return d.data.countrycode
            ? require("../../../../../../static" +
                this.getCountryImgUrl(d.data.countrycode))
            : "";
        })
        .attr("x", function (d) {
          return self.config.rectWidth / 2 - (d.depth !== 0 ? 33 : 0);
        })
        .attr("y", (d) => {
          return -(this.config.rectHeight / 2) - 6;
        })
        .attr("width", function (d) {
          return d.depth !== 0 && d.data.countrycode && !self.isPerson(d)
            ? 35
            : 0;
        })
        .attr("height", function (d) {
          return d.depth !== 0 && d.data.countrycode && !self.isPerson(d)
            ? 20
            : 0;
        });

      // 控股比例
      nodeOfUpItemGroup
        .append("text")
        .attr("id", "fundedratio")
        .attr("x", (d) => {
          return -7;
        })
        .attr("y", (d) => {
          return 60;
        })
        .text((d) => {
          if (d.depth !== 0) {
            return d.data.fundedratio ? d.data.fundedratio + "%" : "";
          }
        })
        .attr("fill", function (d) {
          return self.isPerson(d) ? "#FA6B64" : "#7A9EFF";
        })
        .style("font-family", "DMSans DMSans")
        .style("font-size", (d) => 14);

      // 增加展开按钮
      const expandBtnUp = nodeOfUpItemGroup
        .append("g")
        .attr("class", "expandBtn")
        .attr("transform", (d) => {
          return `translate(${0},${-this.config.rectHeight / 2})`;
        })
        .style("display", (d) => {
          // 如果是根节点，不显示
          if (d.depth === 0) {
            return "none";
          }
          if (d.children) {
            return "block";
          }
          // 如果没有子节点，则不显示
          if (!d.data.sharesflag) {
            return "none";
          }
        })
        .on("click", (e, d) => {
          if (d.children) {
            d.children = null;
            // this.update(d);

            const node = this.findNodeById(
              this.d3ShowData,
              d.data.aaa_id,
              "parent"
            );
            if (node) {
              node.children = [];
              node.parents = [];
            }
            this.$nextTick(() => {
              this.drawChart();
            });
          } else {
            this.getCompanyDetailchirt(d.data.aaa_id, d.data.countrycode, e, d);
          }
          // this.update(d);
        });

      expandBtnUp
        .append("circle")
        .attr("r", 8)
        .attr("fill", "#7A9EFF")
        .attr("cy", -8);

      expandBtnUp
        .append("text")
        .attr("text-anchor", "middle")
        .attr("fill", "#ffffff")
        .attr("y", -3)
        .style("font-size", 16)
        .style("font-family", "微软雅黑")
        .text((d) => {
          return d.children ? "-" : "+";
        });

      const link2 = this.gLinks
        .selectAll("path.linkOfUpItem")
        .data(linksOfUp, (d) => d.target.data.aaa_id);

      const linkUp = link2
        .enter()
        .append("path")
        .attr("class", "linkOfUpItem")
        .attr("d", (d) => {
          let o = {
            source: {
              x: source.x0,
              y: source.y0,
            },
            target: {
              x: source.x0,
              y: source.y0,
            },
          };
          return this.drawLink(o);
        })
        .attr("fill", "none")
        .attr("stroke", "#D3D3D3")
        .attr("stroke-width", 1)
        .attr("marker-end", "url(#markerOfUp)");

      // 有元素update更新和元素新增enter的时候
      node2
        .merge(nodeOfUpItemGroup)
        .transition(myTransition)
        .attr("transform", (d) => {
          return `translate(${d.x},${d.y})`;
        })
        .attr("fill-opacity", 1)
        .attr("stroke-opacity", 1);
      // 有元素消失时
      node2
        .exit()
        .transition(myTransition)
        .remove()
        .attr("transform", (d) => {
          return `translate(${source.x0},${source.y0})`;
        })
        .attr("fill-opacity", 0)
        .attr("stroke-opacity", 0);
      link2.merge(linkUp).transition(myTransition).attr("d", this.drawLink);
      link2
        .exit()
        .transition(myTransition)
        .remove()
        .attr("d", (d) => {
          let o = {
            source: {
              x: source.x,
              y: source.y,
            },
            target: {
              x: source.x,
              y: source.y,
            },
          };
          return this.drawLink(o);
        });

      /***  绘制子公司树(下)  ***/
      const nodes = this.gNodes
        .selectAll("g.nodeOfDownItemGroup")
        .data(nodesOfDown, (d) => {
          return d.data.aaa_id;
        });
      const nodeOfDownItemGroup = nodes
        .enter()
        .append("g")
        .attr("class", "nodeOfDownItemGroup")
        .attr("transform", (d) => {
          return `translate(${source.x0},${source.y0})`;
        })
        .attr("fill-opacity", 0)
        .attr("stroke-opacity", 0)
        .style("cursor", "pointer")
        .on("mouseover", function (mouseEvent, node) {
          let g = d3.select(this);
          g.select("#rectG").style("display", "block");
          let oldTooltip = g.select("#tooltip");
          // 如果宿主元素中包含svg标签了，那么则删除这个标签，再重新生成一个
          if (!oldTooltip.empty()) {
            oldTooltip.remove();
          }
          if (self.isCN(node)) {
            // 国内公司
            self.item.companyName = node.data.entname;
            self.item.companyCountry = node.data.countrycode;
          } else {
            // 国际公司
            self.item.companyName = node.data.entname;
            self.item.companyCountry = node.data.countrycode;
          }
          self.$nextTick(() => {
            self.tooltip = d3.select("#borrow>#tooltip").node().cloneNode(true);
            g.select("#foreignObject").node().appendChild(self.tooltip);
            let tooltipG = g.select("#tooltip");
            if (self.isCN(node)) {
              tooltipG
                .select("#entname")
                .text(node.data.entname ? node.data.entname : "");
              tooltipG
                .select("#entstatus")
                .text(node.data.entstatus ? node.data.entstatus : "");
              tooltipG
                .select("#country")
                .text(
                  "Country：" + (node.data.country ? node.data.country : "")
                );
              tooltipG.select("#enttype").text(node.data.enttype);
            } else {
              tooltipG
                .select("#entname")
                .text(node.data.entname ? node.data.entname : "");
              tooltipG
                .select("#entstatus")
                .text(node.data.entstatus ? node.data.entstatus : "");
              tooltipG
                .select("#country")
                .text(
                  "Country：" + (node.data.country ? node.data.country : "")
                );
              tooltipG
                .select("#enttype")
                .text(node.data.enttype ? node.data.enttype : "");
            }
            // 提示框在营颜色
            let selection = tooltipG.select("#entstatus");
            let entstatusTxt = selection.text();
            switch (entstatusTxt) {
              case "Active":
                selection.style("color", "#3FB92F");
                selection.style("background", "#F3FFF2");
                selection.style("border", "1px solid #3FB92F");
                break;
              default:
                selection.style("color", "#F89898");
                selection.style("background", "#FDE2E2");
                selection.style("border", "1px solid #F89898");
                break;
            }
            tooltipG.style("display", "flex");
          });
        })
        .on("mouseout", function (mouseEvent, node) {
          let g = d3.select(this);
          g.select("#rectG").style("display", "none");
        });
      // 下部分 外层的矩形框
      nodeOfDownItemGroup
        .append("rect")
        .attr("id", "mainRect")
        .attr("display", (d) => {
          return d.depth === 0 ? "none" : "block";
        })
        .attr("width", (d) => {
          return this.config.rectWidth;
        })
        .attr("height", (d) => {
          return this.config.rectHeight;
        })
        .attr("x", (d) => {
          return -(this.config.rectWidth / 2);
        })
        .attr("y", (d) => {
          return -(this.config.rectHeight / 2);
        })
        .attr("rx", 4) //   边缘圆角
        .attr("stroke-width", 1)
        .attr("stroke", (d) => {
          return "#D3D3D3";
        })
        .attr("fill", (d) => {
          return "#FFFFFF";
        })
        .on("click", (e, d) => {
          this.nodeClickEvent(e, d);
        })
        .on("mouseover", function (mouseEvent, node) {
          let g = d3.select(this.parentNode);
          g.select("#mainRect").style("stroke", "#016FF6");
          g.select("#mainCompanyName").style("fill", "#016FF6");
          g.select("#subCompanyName").style("fill", "#016FF6");
        })
        .on("mouseout", function (mouseEvent, node) {
          let g = d3.select(this.parentNode);
          g.select("#mainRect").style("stroke", "#D3D3D3");
          g.select("#mainCompanyName").style("fill", "#1A2332");
          g.select("#subCompanyName").style("fill", "#1A2332");
        });
      this.rectHoverDiv(nodeOfDownItemGroup);
      // 文本主标题
      nodeOfDownItemGroup
        .append("text")
        .attr("id", (d) => {
          if (d.depth === 0) {
            return "rootCompanyName";
          } else {
            return "mainCompanyName";
          }
        })
        .attr("x", (d) => {
          return 0;
        })
        .attr("y", (d) => {
          if (d.depth === 0) {
            return 10;
          }
          return -4;
        })
        .attr("text-anchor", (d) => {
          return "middle";
        })
        .text((d) => {
          if (d.depth === 0) {
            return d.data.entname;
          } else {
            if (self.isPerson(d)) {
              return d.data.entname && d.data.entname.length > 11
                ? d.data.entname.substring(0, 11)
                : d.data.entname;
            } else {
              if (self.isCN(d)) {
                return d.data.entname && d.data.entname.length > 11
                  ? d.data.entname.substring(0, 11)
                  : d.data.entname;
              } else {
                return d.data.entname && d.data.entname.length > 18
                  ? d.data.entname.substring(0, 18)
                  : d.data.entname;
              }
            }
          }
        })
        .attr("fill", (d) => {
          if (d.depth === 0) {
            return "#FFFFFF";
          }
          return "#1A2332";
        })
        .style("font-size", (d) => (d.depth === 0 ? 16 : 14))
        .style("font-family", "DMSans DMSans")
        .style("font-weight", "normal")
        // .append("svg:title")
        // .text((d) => d.data.entname)
        .style("pointer-events", "none");

      // 副标题
      nodeOfDownItemGroup
        .append("text")
        .attr("id", "subCompanyName")
        .attr("x", (d) => {
          return 0;
        })
        .attr("fill", (d) => {
          return "#1A2332";
        })
        .attr("y", (d) => {
          return 15;
        })
        .attr("text-anchor", (d) => {
          return "middle";
        })
        .text((d) => {
          if (d.depth !== 0) {
            if (self.isCN(d)) {
              let subTitle = d.data.entname ? d.data.entname.substring(11) : "";
              if (subTitle.length > 10) {
                return subTitle.substring(0, 10) + "...";
              }
              return subTitle;
            } else {
              let subTitle = d.data.entname ? d.data.entname.substring(18) : "";
              if (subTitle.length > 17) {
                return subTitle.substring(0, 17) + "...";
              }
              return subTitle;
            }
          }
        })
        .style("font-size", (d) => 14)
        .style("font-family", "DMSans DMSans")
        .style("font-weight", "normal")
        // .append("svg:title")
        // .text((d) => d.data.entname)
        .style("pointer-events", "none");
      //融资轮次
      // nodeOfDownItemGroup
      //   .append("svg:rect")
      //   .attr("x", "-84")
      //   .attr("y", "14")
      //   .attr("rx", 5)
      //   .attr("width", (d) => {
      //     if (d.depth !== 0 && d.data.rounds) {
      //       return this.config.rectWidth - 2;
      //     }
      //   })
      //   .attr("height", "20")
      //   .style("fill", "#E5F3FE");
      // nodeOfDownItemGroup
      //   .append("text")
      //   .attr("x", "0")
      //   .attr("dy", "30")
      //   .attr("text-anchor", "middle")
      //
      //   .attr("class", "linkname")
      //   // .style("fill", "#666")
      //   .style("font-size", 12)
      //   .attr("fill", "#008BF8")
      //   .text(function (d) {
      //     if (d.depth !== 0 && d.data.rounds) {
      //       let str = "融资轮次：" + d.data.rounds;
      //       return str.length > 13 ? str.substring(0, 18) + ".." : str;
      //     }
      //   });

      // 控股比例
      nodeOfDownItemGroup
        .append("text")
        .attr("class", "fundedratio")
        .attr("x", (d) => {
          return -14;
        })
        .attr("y", (d) => {
          return -60;
        })
        .text((d) => {
          if (d.depth !== 0) {
            return d.data.fundedratio ? d.data.fundedratio + "%" : "";
          }
        })
        .attr("fill", "#0084FF")
        .style("font-family", "DMSans DMSans")
        .style("font-size", 14);
      // nodeOfDownItemGroup
      //   .append("svg:rect")
      //   .attr("x", "-40")
      //   .attr("y", "-70")
      //   .attr("rx", 2)
      //   .attr("width", function (d) {
      //     return d.depth !== 0 && d.data.fundedratio ? 30 : 0;
      //   })
      //   .attr("height", function (d) {
      //     return d.depth !== 0 && d.data.fundedratio ? 20 : 0;
      //   })
      //   .style("fill", "#EBF5FF");
      // nodeOfDownItemGroup
      //   .append("text")
      //   .attr("x", "-37")
      //   .attr("dy", "-55")
      //   .attr("text-anchor", "start")
      //   .style("fill", "#0084FF")
      //   .style("font-size", 12)
      //   .text(function (d) {
      //     return d.depth !== 0 && d.data.fundedratio ? "控股" : "";
      //   });
      //注销
      nodeOfDownItemGroup
        .append("svg:rect")
        .attr("x", (d) => {
          return -(this.config.rectWidth / 2) - 1;
        })
        .attr("y", (d) => {
          return -(this.config.rectHeight / 2) - 6;
        })
        .attr("rx", 2) //   边缘圆角
        .attr("width", function (d) {
          if (d.depth !== 0) {
            if (self.isCN(d)) {
              return d.data.entstatus != null
                ? d.data.entstatus.length * 13 + 9
                : 0;
            } else {
              return d.data.entstatus != null
                ? d.data.entstatus.length * 8 + 9
                : 0;
            }
          }
          return 0;
        })
        .attr("height", function (d) {
          return d.depth !== 0 && d.data.entstatus != null ? 20 : 0;
        })
        .style("fill", (d) => {
          let fillColor = "#FDE2E2";
          // 左上方格填充颜色
          if (self.isCN(d)) {
            // 中国
            if (d.data.entstatus != null) {
              switch (d.data.entstatus) {
                case "Active": //在营
                  fillColor = "#F3FFF2";
                  break;
                case "Active": //在业
                  fillColor = "#F3FFF2";
                  break;
              }
            }
          } else {
            // 国际
            if (d.data.entstatus != null) {
              switch (d.data.entstatus) {
                case "Active": //在营
                  fillColor = "#F3FFF2";
                  break;
                default:
                  fillColor = "#FDE2E2";
                  break;
              }
            }
          }
          return fillColor;
        });
      nodeOfDownItemGroup
        .append("image")
        .attr("xlink:href", (d) => {
          return d.data.countrycode
            ? require("../../../../../../static" +
                this.getCountryImgUrl(d.data.countrycode))
            : "";
        })
        .attr("x", function (d) {
          return self.config.rectWidth / 2 - (d.depth !== 0 ? 33 : 0);
        })
        .attr("y", (d) => {
          return -(this.config.rectHeight / 2) - 6;
        })
        .attr("width", function (d) {
          return d.depth !== 0 ? 35 : 0;
        })
        .attr("height", function (d) {
          return d.depth !== 0 ? 20 : 0;
        });
      nodeOfDownItemGroup
        .append("text")
        .attr("x", (d) => {
          return -(this.config.rectWidth / 2) + 5;
        })
        .attr("dy", (d) => {
          return -(this.config.rectHeight / 2) + 8;
        })
        .attr("text-anchor", "start")
        .style("fill", (d) => {
          let fillColor = "#F89898";
          if (self.isCN(d)) {
            if (d.data.entstatus != null) {
              switch (d.data.entstatus) {
                case "Active": //在业
                  fillColor = "#3FB92F";
                  break;
                  break;
                default:
                  fillColor = "#F89898";
                  break;
              }
            }
          } else {
            if (d.data.entstatus != null) {
              switch (d.data.entstatus) {
                case "Active": //在营
                  fillColor = "#3FB92F";
                  break;
                default:
                  fillColor = "#F89898";
                  break;
              }
            }
          }
          return fillColor;
        })
        .style("font-size", 12)
        .text(function (d) {
          if (d.depth !== 0) {
            if (self.isCN(d)) {
              return d.data.entstatus != null ? d.data.entstatus : "";
            } else {
              return d.data.entstatus != null ? d.data.entstatus : "";
            }
          }
          return "";
        });
      // 增加展开按钮
      const expandBtnDown = nodeOfDownItemGroup
        .append("g")
        .attr("class", "expandBtn")
        .attr("transform", (d) => {
          return `translate(${0},${this.config.rectHeight / 2})`;
        })
        .style("display", (d) => {
          // 如果是根节点，不显示
          if (d.depth === 0) {
            return "none";
          }
          if (d.children) {
            return "block";
          }
          // 如果没有子节点，则不显示
          if (d.data.entinvflag != "1") {
            return "none";
          }
        })
        .on("click", (e, d) => {
          if (d.children) {
            d.children = null;
            // this.update(d);
            const node = this.findNodeById(
              this.d3ShowData,
              d.data.aaa_id,
              "children"
            );
            if (node) {
              node.children = [];
              node.parents = [];
            }
            this.$nextTick(() => {
              this.drawChart();
            });
          } else {
            this.getCompanyDetailchirt(d.data.aaa_id, d.data.countrycode, e, d);
          }
          // this.update(d);
        });

      expandBtnDown
        .append("circle")
        .attr("r", 8)
        .attr("fill", "#7A9EFF")
        .attr("cy", 8);

      expandBtnDown
        .append("text")
        .attr("text-anchor", "middle")
        .attr("fill", "#ffffff")
        .attr("y", 13)
        .style("font-size", 16)
        .style("font-family", "微软雅黑")
        .text((d) => {
          return d.children ? "-" : "+";
        });

      const links = this.gLinks
        .selectAll("path.linkOfDownItem")
        .data(linksOfDown, (d) => d.target.data.aaa_id);
      //下部分 线条
      const linkDown = links
        .enter()
        .append("path")
        .attr("class", "linkOfDownItem")
        .attr("d", (d) => {
          let o = {
            source: {
              x: source.x0,
              y: source.y0,
            },
            target: {
              x: source.x0,
              y: source.y0,
            },
          };
          return this.drawLink(o);
        })
        .attr("fill", "none")
        .attr("stroke", "#D3D3D3")
        .attr("stroke-width", 1)
        .attr("marker-end", "url(#markerOfDown)");

      // 有元素update更新和元素新增enter的时候
      nodes
        .merge(nodeOfDownItemGroup)
        .transition(myTransition)
        .attr("transform", (d) => {
          return `translate(${d.x},${d.y})`;
        })
        .attr("fill-opacity", 1)
        .attr("stroke-opacity", 1);

      // 有元素消失时
      nodes
        .exit()
        .transition(myTransition)
        .remove()
        .attr("transform", (d) => {
          return `translate(${source.x0},${source.y0})`;
        })
        .attr("fill-opacity", 0)
        .attr("stroke-opacity", 0);

      links.merge(linkDown).transition(myTransition).attr("d", this.drawLink);

      links
        .exit()
        .transition(myTransition)
        .remove()
        .attr("d", (d) => {
          let o = {
            source: {
              x: source.x,
              y: source.y,
            },
            target: {
              x: source.x,
              y: source.y,
            },
          };
          return this.drawLink(o);
        });

      // node数据改变的时候更改一下加减号
      const expandButtonsSelection = d3.selectAll("g.expandBtn");
      expandButtonsSelection
        .select("text")
        .transition()
        .text((d) => {
          return d.children ? "-" : "+";
        });

      this.rootOfDown.eachBefore((d) => {
        d.x0 = d.x;
        d.y0 = d.y;
      });
      this.rootOfUp.eachBefore((d) => {
        d.x0 = d.x;
        d.y0 = d.y;
      });
    },

    drawLink({ source, target }) {
      const halfDistance = (target.y - source.y) / 3;
      const halfY = source.y + halfDistance;
      return `M${source.x},${source.y} L${source.x},${halfY} ${target.x},${halfY} ${target.x},${target.y}`;
    },
    // 展开所有的节点
    expandAllNodes() {
      this.drawChart({
        type: "all",
      });
    },
    // 将所有节点都折叠
    foldAllNodes() {
      this.drawChart({
        type: "fold",
      });
    },
    onCompanyDetail(aaaId,entname,countrycode){
      if(aaaId){
              let newscountry = JSON.parse(localStorage.getItem("countryList"))[0].countryList
                    let companyCountryEn = ""
            newscountry.map((item) => {
                if (item.countryCode == countrycode) {
                    companyCountryEn = item.dowjonesCountrycode;
                }
            });
            let routeData = this.$router.resolve({
                path:
                    "/index/company/detals/" +
                    aaaId +
                    "/background/snapshot?id3a=" +
                   aaaId +
                    "&companyCountry=" +
                    countrycode +
                    "&companyCountryEn=" +
                    companyCountryEn +
                    '&keword=' + this.$route.query.keword,
            });

            window.open(routeData.href, "_blank");
      }
           

    },
    //点击节点获取节点数据
    nodeClickEvent(e, node) {
      if (!this.isPerson(node) && node.depth != 0) {
        this.onCompanyDetail(
          node.data.aaa_id,
          node.data.entname,
          node.data.countrycode
        )
      }
    },
    //全屏-退出全屏
    toggleFullScreen(e) {
      this.isFullscreen = !this.isFullscreen;
      this.FullScreen(document.getElementById("borrow"));
    },
    //全屏
    fullele() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        null
      );
    },
    //判断是否为全屏
    checkFull() {
      return !(document.webkitIsFullScreen || this.fullele());
    },
    //全屏-退出全屏
    FullScreen(el) {
      if (this.isFullscreen) {
        //退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (!document.msRequestFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        //进入全屏
        if (el.requestFullscreen) {
          el.requestFullscreen();
        } else if (el.mozRequestFullScreen) {
          el.mozRequestFullScreen();
        } else if (el.webkitRequestFullscreen) {
          //改变平面图在google浏览器上面的样式问题
          el.webkitRequestFullscreen();
        } else if (el.msRequestFullscreen) {
          this.isFullscreen = true;
          el.msRequestFullscreen();
        }
      }
    },
    //下载为图片
    downloadImpByChart(chartName) {
      //得到svg的真实大小
      let box = document.querySelector("svg").getBBox(),
        x = box.x,
        y = box.y,
        width = box.width * 2,
        height = box.height * 2;
      //克隆svg
      let svg = document.getElementById("mysvg");
      let node = svg.cloneNode(true);
      //重新设置svg的width,height,viewbox
      node.setAttribute("width", width * 2);
      node.setAttribute("height", height * 2);
      node.setAttribute("viewBox", [x, y, width, height]);
      this.downloadSvgFn(
        node,
        width,
        height,
        this.d3ShowData.countrycode === "CN"
          ? this.d3ShowData.entname
          : this.d3ShowData.entname
      );
    },
    //下载
    downloadSvgFn(svg, width, height, rootName) {
      let serializer = new XMLSerializer();
      let source =
        '<?xml version="1.0" standalone="no"?>\r\n' +
        serializer.serializeToString(svg);
      let image = new Image();
      image.src =
        "data:image/svg+xml;charset=utf-8," + encodeURIComponent(source);
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = width + 40;
        canvas.height = height + 40;
        let context = canvas.getContext("2d");
        context.rect(0, 0, canvas.width, canvas.height);
        context.fillStyle = "#fff";
        context.fill();
        context.drawImage(image, 20, 20);
        let url = canvas.toDataURL("image/png");
        let a = document.createElement("a");
        a.download = `${rootName}-股权穿透图.png`;
        a.href = url;
        a.click();
      };
    },
    rectHoverDiv(nodeOfDownItemGroup) {
      let rectHoverDiv = {
        x: 0,
        y: 0,
      };
      let rectHoverDivRoot = {
        x: 0,
        y: 0,
      };
      let self = this;
      let rectG = nodeOfDownItemGroup
        .append("g")
        .attr("id", "rectG")
        .style("display", "none");
      // rectG.append("rect").attr('id', 'rectHoverDiv')
      //   .attr("width", (d) => {
      //     return this.config.rectHoverDivWidth;
      //   })
      //   .attr("height", (d) => {
      //     return this.config.rectHoverDivHeight;
      //   })
      //   .attr("x", (d) => {
      //     if (d.depth === 0) {
      //       rectHoverDivRoot.x = (((d.data.entname.length + 6) * 16) / 2 + 10)
      //       return rectHoverDivRoot.x;
      //     }
      //     rectHoverDiv.x = ((this.config.rectWidth / 2) )
      //     return rectHoverDiv.x;
      //   })
      //   .attr("y", (d) => {
      //     if (d.depth === 0) {
      //       rectHoverDivRoot.y = -20;
      //       return rectHoverDivRoot.y;
      //     }
      //     rectHoverDiv.y = -(this.config.rectHeight / 2)
      //     return rectHoverDiv.y;
      //   })
      //   .attr("rx", 4) //   边缘圆角
      //   .attr("stroke-width", 1)
      //   .attr("stroke", (d) => {
      //     return "#D3D3D3";
      //   })
      //   .attr("fill", (d) => {
      //     return "#FFFFFF";
      //   })

      //
      // rectG.append("rect").attr("x", (d) => {
      //   if (d.depth === 0) {
      //     return rectHoverDivRoot.x + 13;
      //   }
      //   return rectHoverDiv.x + 13;
      // })
      //   .attr("y", (d) => {
      //     if (d.depth === 0) {
      //       return rectHoverDivRoot.y + 13;
      //     }
      //     return rectHoverDiv.y + 13;
      //   })
      //   .attr("width", function (d) {
      //     return 32;
      //   })
      //   .attr("height", function (d) {
      //     return 32;
      //   })
      //   .attr("rx", 4) //   边缘圆角
      //   .attr("stroke-width", 1)
      //   .attr("stroke", (d) => {
      //     return "#D3D3D3";
      //   })
      //   .attr("fill", (d) => {
      //     return "#FFFFFF";
      //   })
      //
      //
      // rectG.append("image")
      //   .attr('xlink:href', require("@/assets/images/company1.png"))
      //   .attr("x", (d) => {
      //     if (d.depth === 0) {
      //       return rectHoverDivRoot.x + 15;
      //     }
      //     return rectHoverDiv.x + 15;
      //   })
      //   .attr("y", (d) => {
      //     if (d.depth === 0) {
      //       return rectHoverDivRoot.y + 15;
      //     }
      //     return rectHoverDiv.y + 15;
      //   })
      //   .attr("width", function (d) {
      //     return 28;
      //   })
      //   .attr("height", function (d) {
      //     return 28;
      //   }).on("click", (e, d) => {
      //   this.nodeClickEvent(e, d);
      // })

      rectG
        .append("foreignObject")
        .attr("id", "foreignObject")
        .attr("x", this.config.rectWidth / 2)
        .attr("y", -this.config.rectHeight / 2 - 10)
        .attr("width", "354px")
        .attr("height", "98px");
    },
    isCN(d) {
      // d.data.countrycode === "CN"
      return false;
    },
    // 判断是个人还是企业
    isPerson(d) {
      let flag = false;
      if (
        d.data.aaa_id != "" &&
        d.data.aaa_id != null &&
        d.data.aaa_id != undefined &&
        d.data.enttypecode == "1"
      ) {
        flag = false;
      } else {
        if (d.data.enttypecode == "2") {
          flag = true;
        } else {
          flag = false;
        }

        // flag = true;
      }
      // if (d.data.countrycode === "CN") {
      //   flag = d.data.invtypecode == "1" || d.data.invtypecode == "4";
      // } else {
      //   flag = d.data.invtypecode == "3" || d.data.invtypecode == "8";
      // }
      return flag;
    },
  },
};
</script>

<style scoped>
#borrow {
  background: #fff;
  position: relative;
}

.functionBox {
  padding: 5px;
  position: absolute;
  right: 10px;
  bottom: 45%;
  display: flex;
  flex-direction: column;
  background: #f8f8f8;
  transition: all linear 0.2s;
  border-radius: 8px;
}
.functionBox .functionItem {
  color: #444;
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
}
.functionBox .functionItem > img {
  width: 100%;
  height: 100%;
}
.functionBox .functionItem:hover {
  background: rgb(233, 233, 233);
}
.borrowClass {
  width: 100%;
  height: 100%;
}
.tooltip-hover {
  width: 334px;
  height: 78px;
  margin-left: 10px;
  margin-top: 10px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
}
._company-status-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 20px;
  line-height: 20px;
  padding: 0 7px;
  font-size: 12px;
  border-radius: 4px;
}
</style>
